import { render, staticRenderFns } from "./PermissionsTable.vue?vue&type=template&id=3a144286&scoped=true&"
import script from "./PermissionsTable.vue?vue&type=script&lang=js&"
export * from "./PermissionsTable.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsTable.vue?vue&type=style&index=0&id=3a144286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a144286",
  null
  
)

export default component.exports